import { SeriesLineOptions } from 'highcharts/highstock';
import { DeviceConsumptionResult, DeviceReadingsResult } from 'types';
import { getDataFromPrediction, sortSeries } from '../general';

export const addTankSeries = (
    series: SeriesLineOptions[],
    lastConsumption: number,
    readings: DeviceReadingsResult,
    consumption: DeviceConsumptionResult
) => {
    let lastReading = 0;
    const tankData = [];
    for (const reading of readings.data) {
        if (!reading.hide) {
            tankData.push([reading.time, reading.tank]);
            lastReading = reading.time;
        }
    }
    for (const readingId in consumption) {
        const reading = consumption[readingId];
        if (!!reading.predictions) {
            for (const date in reading.predictions) {
                const prediction = reading.predictions[date];
                const processedPrediction = getDataFromPrediction(
                    prediction,
                    lastConsumption,
                    lastReading
                );
                if (
                    (processedPrediction.tank ||
                        processedPrediction.tank === 0) &&
                    processedPrediction.tank
                ) {
                    tankData.push([
                        processedPrediction.date,
                        processedPrediction.tank,
                    ]);
                }
            }
        }
    }
    const tankSeries: SeriesLineOptions = {
        id: 'tank',
        type: 'line',
        color: '#FF5722',
        marker: {
            enabled: false,
        },
        zoneAxis: 'x',
        zones: [
            {
                value: Number(new Date()),
                color: '#FF5722',
            },
            {
                color: '#ffcbbc',
                dashStyle: 'Dash',
            },
        ],
        yAxis: 0,
        zIndex: 0,
        name: 'tank',
        dataGrouping: { enabled: false },
        data: sortSeries(tankData),
        tooltip: {
            valueDecimals: 1,
            xDateFormat: '%b %e %l:%M %p',
        },
    };
    series.push(tankSeries);
};
